import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row } from 'reactstrap'

import products from '../assets/data/products'
import heroImg from '../assets/images/ps5-hero-hq.webp'
import counterImg from '../assets/images/2.jpg'
import Helmet from '../components/Helmet/Helmet'
import ProductsList from '../components/UI/ProductsList'
import Services from '../services/Services'
import '../styles/home.css'

const Home = () => {
  const collections = useMemo(() => ({
    featured: products.filter((item) => ['mobile', 'computer'].includes(item.category)).slice(0, 4),
    gaming: products.filter((item) => item.category === 'console').slice(0, 4),
    newArrivals: products.filter((item) => ['wireless', 'watch'].includes(item.category)).slice(0, 4),
  }), [])

  return (
    <Helmet title='Home'>
      <section className='hero__section'>
        <Container>
          <div className='hero__shell'>
            <div className='hero__content'>
              <span className='hero__kicker'><i className='ri-flashlight-fill'></i> New tech. Zero guesswork.</span>
              <h1>Upgrade your everyday.</h1>
              <p>Curated phones, laptops, gaming and audio—priced clearly, delivered across Pakistan, and backed by people who know their tech.</p>
              <div className='hero__actions'>
                <Link className='hero__primary' to='/shop'>Explore the collection <i className='ri-arrow-right-line'></i></Link>
                <Link className='hero__secondary' to='/about'>Why shop with us</Link>
              </div>
              <div className='hero__proof'>
                <div><strong>4.8/5</strong><span>Customer rating</span></div>
                <div><strong>24h</strong><span>Order support</span></div>
                <div><strong>14 days</strong><span>Easy returns</span></div>
              </div>
            </div>

            <div className='hero__visual'>
              <span className='hero__visual-label'>Editor’s pick</span>
              <img src={heroImg} alt='Sony PlayStation 5 console' width='899' height='1400' fetchPriority='high' decoding='async' />
              <div className='hero__floating-card'>
                <span>Next-generation play</span>
                <strong>Sony PlayStation 5</strong>
                <Link to='/shop/01'>View details <i className='ri-arrow-right-up-line'></i></Link>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <Services />

      <section className='collection__section'>
        <Container>
          <div className='section__heading-row'>
            <div><span className='section__eyebrow'>Popular right now</span><h2 className='section__title'>Worth the upgrade</h2></div>
            <Link to='/shop' className='text__link'>Shop all <i className='ri-arrow-right-line'></i></Link>
          </div>
          <Row><ProductsList data={collections.featured} /></Row>
        </Container>
      </section>

      <section className='category__section'>
        <Container>
          <div className='category__grid'>
            <Link to='/shop' className='category__tile category__tile--dark'>
              <span>01</span><div><small>Shop collection</small><h3>Phones that do more.</h3><p>Sharp cameras, smooth displays and all-day power.</p></div><i className='ri-arrow-right-up-line'></i>
            </Link>
            <Link to='/shop' className='category__tile category__tile--lime'>
              <span>02</span><div><small>Shop collection</small><h3>Serious play.</h3><p>Consoles and gear built for the next session.</p></div><i className='ri-arrow-right-up-line'></i>
            </Link>
            <Link to='/shop' className='category__tile category__tile--soft'>
              <span>03</span><div><small>Shop collection</small><h3>Work, untethered.</h3><p>Fast laptops for ideas that refuse to sit still.</p></div><i className='ri-arrow-right-up-line'></i>
            </Link>
          </div>
        </Container>
      </section>

      <section className='collection__section collection__section--soft'>
        <Container>
          <div className='section__heading-row'>
            <div><span className='section__eyebrow'>Level up</span><h2 className='section__title'>Game without limits</h2></div>
            <Link to='/shop' className='text__link'>Explore gaming <i className='ri-arrow-right-line'></i></Link>
          </div>
          <Row><ProductsList data={collections.gaming} /></Row>
        </Container>
      </section>

      <section className='feature__banner-section'>
        <Container>
          <div className='feature__banner'>
            <div className='feature__copy'>
              <span className='section__eyebrow'>Gadget Groove pick</span>
              <h2>Power that travels light.</h2>
              <p>The MacBook Pro pairs all-day battery life with the speed to keep up—at home, on campus, or wherever work takes you.</p>
              <Link className='hero__primary' to='/shop/05'>See the MacBook lineup <i className='ri-arrow-right-line'></i></Link>
            </div>
            <div className='feature__image'><span>Lightweight<br />heavyweight.</span><img src={counterImg} alt='MacBook Pro' width='300' height='300' loading='lazy' decoding='async' /></div>
          </div>
        </Container>
      </section>

      <section className='collection__section'>
        <Container>
          <div className='section__heading-row'>
            <div><span className='section__eyebrow'>Fresh picks</span><h2 className='section__title'>Small tech, big difference</h2></div>
            <Link to='/shop' className='text__link'>See new arrivals <i className='ri-arrow-right-line'></i></Link>
          </div>
          <Row><ProductsList data={collections.newArrivals} /></Row>
        </Container>
      </section>
    </Helmet>
  )
}

export default Home
